import FormInput from "../UI/FormInput";
import { useTranslation } from "react-i18next";

const BuildingAreaInput = ({ helpText = null }) => {
  const { t } = useTranslation("form");
  return (
    <FormInput
      label={t("buildingAreaSqFt")}
      placeholder={t("buildingAreaSqFt")}
      id="area_sq_ft"
      type="text"
      autoComplete="building area"
      required={false}
      helperText={helpText}
      attr={{ maxLength: 9 }}
    />
  );
};
export default BuildingAreaInput;